import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { finalize } from 'rxjs';

import { MessageService } from 'primeng/api';

import { AiChatQueryModel, AiChatQueryResponseModel } from '../../api/ai/ai.model';
import { AiManagerService } from '../../api/ai/ai-manager.service';
import { ApiService } from '../../api/common/api.service';
import { DeviceManagerService } from '../../core/services/device-manager.service';
import { WaitingIndicatorComponent } from '../waiting-indicator/waiting-indicator.component';
import { LocalStorageManagerService } from '../../core/services/local-storage-manager.service';
import { Dialog } from 'primeng/dialog';

@Component({
	selector: 'mycampapp-ai-assistant',
	templateUrl: './ai-assistant.component.html',
	styleUrls: ['./ai-assistant.component.less'],
	animations: WaitingIndicatorComponent.animations,
})
export class AiAssistantComponent implements OnInit, AfterViewInit
{
	@ViewChild('dialog', {static: false}) dialog?: Dialog;
	@ViewChild('responseArea', {static: false}) responseArea?: ElementRef;
	@Output() closed = new EventEmitter();

	aiQuery = '';
	aiResponses: AiChatQueryResponseModel[] = [];
	busy = false;
	visible = true;

	constructor(public deviceManager: DeviceManagerService,
	            private messageService: MessageService,
	            private localCacheManager: LocalStorageManagerService,
	            private aiManager: AiManagerService) { }

	ngOnInit()
	{
	}

	ngAfterViewInit()
	{
		let dialogPosition = 		this.localCacheManager.aiDialogStyle;
		if (this.dialog == null || dialogPosition == null || dialogPosition.length === 0) return;
		let styles = JSON.parse(dialogPosition);
		if (styles.position == null) return;

		// Check boundaries and don't continue resizing if the dialog is at all hidden
		let left = parseInt(styles.left);
		let top = parseInt(styles.top);
		let width = parseInt(styles.width);
		let height = parseInt(styles.height);
		if (left + width > window.innerWidth || top + height > window.innerHeight) return;

		let dialogStyle = this.dialog.el.nativeElement.querySelector('.p-dialog').style;
		dialogStyle.position = styles.position;
		dialogStyle.left = styles.left;
		dialogStyle.top = styles.top;
		dialogStyle.width = styles.width;
		dialogStyle.height = styles.height;
	}

	async onSendAIQuery()
	{
		this.busy = true;
		this.aiManager.queryChat(new AiChatQueryModel({ UserQueries: [ this.aiQuery] }))
			.pipe(finalize(() => this.busy = false))
			.subscribe({
				next: (response: AiChatQueryResponseModel) =>
				{
					this.aiQuery = '';
					this.aiResponses.push(response);
					setTimeout(() => this.typeInResponse(response), 10);
				},
				error: error => this.messageService.add({ severity: 'error', summary: 'Error sending AI query', detail: ApiService.getMessage(error) })
			});
	}

	getHTMLForResponse(content: string | null): string
	{
		if (content == null) return '';

		const fullHtml = content.replace('\n', '<br/><br/>').replace(/\[(.*?)\]/g, '');
		return fullHtml;
	}

	typeInResponse(queryResponse: AiChatQueryResponseModel): void
	{
		queryResponse.Responses.forEach((response, index) =>
		{
			let div = document.querySelector(`.response-${queryResponse.QueryId}-${index}`);
			if (div == null) return;
			let responseWords = this.getHTMLForResponse(response).split(' ');
			let wordIndex = 0;
			const interval = setInterval(() =>
			{
				div!.innerHTML += (div!.innerHTML.length === 0 ? '' : ' ') + responseWords[wordIndex++];
				this.scrollToBottom();
				if (wordIndex === responseWords.length) {
					clearInterval(interval);
				}
			}, 50);
		});
	}

	private scrollToBottom(): void
	{
		setTimeout(() =>
		{
			if (this.responseArea == undefined) return;
			this.responseArea.nativeElement.scrollTop = this.responseArea.nativeElement.scrollHeight;
		}, 500);
	}

	onDialogHiding()
	{
		this.closed.emit();
	}

	onDialogMoved(event: any)
	{
		if (this.dialog == null) return;
		let style = this.dialog.el.nativeElement.querySelector('.p-dialog').style;
		if (style == null) return;
		this.localCacheManager.aiDialogStyle = JSON.stringify({
			position: style.position,
			left: style.left,
			top: style.top,
			width: style.width,
			height: style.height
		});
	}

	onRateResponse(queryId: number, rating: number)
	{
		this.busy = true;
		this.aiManager.rateQuery(queryId, rating)
			.pipe(finalize(() => this.busy = false))
			.subscribe({
				next: () => { },
				error: error => this.messageService.add({ severity: 'error', summary: 'Error sending AI rating', detail: ApiService.getMessage(error) })
			});
	}
}
